var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.hide_title)?_c('submission-title',{attrs:{"form_status":_vm.form_submission.form_status}}):_vm._e(),_vm._v(" "),_c('submission-subtitle',{attrs:{"form_status":_vm.form_submission.form_status}}),_vm._v(" "),_c('tool-certificate-content',{attrs:{"certificate":_vm.certificate ?? _vm.form_submission?.certificate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }